module.exports = __webpack_public_path__ + "img/partC3.2daa6759.png";